import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { ZefDialogModule } from '@zerops/zef/dialog';
import { ZefScrollbarComponent } from '@zerops/zef/scrollbar';
import { ZefProgressErrorModule } from '@zerops/zef/progress-error';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { NgrxFormsModule } from 'ngrx-forms';
import { ZefFormsModule, ZefFormFieldModule } from '@zerops/zef/forms';
import { CodeFieldModule } from '@zerops/zui/code-field';
import { FormSectionModule } from '@zerops/zui/form-section';
import { ZuiSeparatorComponent } from '@zerops/zui/separator';
import { ZuiClaudeMarkComponent } from '@zerops/zui/claude-mark';
import { ZuiCodexMarkComponent } from '@zerops/zui/codex-mark';
import { ZuiAntigravityMarkComponent } from '@zerops/zui/antigravity-mark';
import { ZuiGrokMarkComponent } from '@zerops/zui/grok-mark';
import { ZuiCursorMarkComponent } from '@zerops/zui/cursor-mark';
import { ZuiSecretFieldComponent } from '@zerops/zui/secret-field';
import { ControlPlaneDialogFeature } from './control-plane-dialog.feature';
import { ControlPlaneDialogEffect } from './control-plane-dialog.effect';

@NgModule({
  declarations: [
    ControlPlaneDialogFeature
  ],
  imports: [
    CommonModule,
    ZefDialogModule,
    ZefScrollbarComponent,
    ZefProgressErrorModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatRadioModule,
    MatIconModule,
    MatRippleModule,
    NgrxFormsModule,
    ZefFormsModule,
    ZefFormFieldModule,
    CodeFieldModule,
    FormSectionModule,
    ZuiSeparatorComponent,
    ZuiClaudeMarkComponent,
    ZuiCodexMarkComponent,
    ZuiAntigravityMarkComponent,
    ZuiGrokMarkComponent,
    ZuiCursorMarkComponent,
    ZuiSecretFieldComponent,
    EffectsModule.forFeature([ ControlPlaneDialogEffect ])
  ],
  exports: [
    ControlPlaneDialogFeature
  ]
})
export class ControlPlaneDialogModule {}
